import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { tickets } from '../api';
import queryString from 'query-string';

export const DRIVER_TICKETS_TODAY_QUERY = { dateOption: 'Today' };

export const useListDriverTickets = queryParams => {
  const { entityRef } = useParams();
  return useQuery({
    queryKey: ['list-driver-tickets', entityRef, queryString.stringify(queryParams)],
    queryFn: () => tickets.listDriverTickets({ entityRef, queryParams }),
    refetchInterval: 60000,
    refetchOnWindowFocus: false,
  });
};

export const isPendingTicket = (ticket, excludeCrn) =>
  ticket?.customerStatus?.statusCode === 'PENDING' && !ticket?.isVoided && ticket?.crn !== excludeCrn;

export const findNextPendingDriverTicket = async (entityRef, excludeCrn) => {
  const driverTickets = await tickets.listDriverTickets({
    entityRef,
    queryParams: DRIVER_TICKETS_TODAY_QUERY,
  });
  return driverTickets?.findLast(item => isPendingTicket(item, excludeCrn));
};
